import BaseModelAPI from '../BaseModelAPI';

export default class JobPositionList extends BaseModelAPI {

	static entity = 'jobpositionlist'
	static entityName = 'jobposition';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
